import { useAppDispatch, useAppSelector } from 'store/store-hooks';
import { IntroKeys } from 'components/app/intro/intro-keys';
import { setPlayAction } from 'components/app/editor/_mediator/editor-actions.slice';
import { setSbPlayback, setSbWsPlayback } from 'components/app/storyboard/_mediator/sb.slice';

import { AppButton } from 'components/app/app-components/app-button/app-button';
import { HoverBtn } from 'components/app/app-components/hover-btn/hover-btn';
import { ActionsBtnOpt } from './actions-btn-option';

export const ActionsPlay = () => {
  const sbPlayback = useAppSelector((state) => state.sb.sbPlayback);
  const sbWsPlayback = useAppSelector((state) => state.sb.sbWsPlayback);
  const playAction = useAppSelector((state) => state.editor__actions.playAction);
  const isPlaying = sbPlayback || sbWsPlayback;
  const dispatch = useAppDispatch();

  const playAll = () => {
    dispatch(setPlayAction('all'));
    dispatch(setSbPlayback());
  };

  const playAudio = () => {
    dispatch(setPlayAction('audio'));
    dispatch(setSbWsPlayback());
  };

  const onAction = () => {
    switch (playAction) {
      case 'all':
        playAll();
        break;
      case 'audio':
        playAudio();
        break;
    }
  };

  return (
    <HoverBtn
      button={
        <AppButton
          onClick={onAction}
          data-intro={IntroKeys.sbPlay}
          tip={isPlaying ? 'Pause storyboard preview' : 'Preview storyboard'}
          tipPosition="bottom"
        >
          {isPlaying ? 'Pause' : 'Play'}
        </AppButton>
      }
    >
      <ActionsBtnOpt
        title="Play All"
        desc="Audio track + selected video track"
        onClick={playAll}
        selected={playAction === 'all'}
      />
      <ActionsBtnOpt title="Play Audio" desc="Audio track only" onClick={playAudio} selected={playAction === 'audio'} />
    </HoverBtn>
  );
};
